import { useState, useEffect } from "react"

import NavBarCrossIconMobile from '../SvgComponents/NavBarCrossIconMobile'
import NavBarHamburgerIconMobile from '../SvgComponents/NavBarHamburgerIconMobile'
import DropdownPageLinkForMobileView from './NavBarComponents/DropdownPageLinkForMobileView'
import DropdownPageLinkForWebView from './NavBarComponents/DropdownPageLinkForWebView'
import MorePages from "./NavBarComponents/MorePages"
import NavBarContainer from './NavBarComponents/NavBarContainer'
import SimplePageLinkForMobileView from './NavBarComponents/SimplePageLinkForMobileView'
import SimplePageLinkForWebView from './NavBarComponents/SimplePageLinkForWebView'

function NavBar(props: {
  data: any
}) {

  const [mobileNavBar, setMobileNavBar] = useState<boolean>(false);

  const website_language = localStorage.getItem("website_language");

  let languagePages: Array<any> = [];
  let orderedPagesArray: Array<any> = [];

  const [pages, setPages] = useState<Array<any>>([]);

  useEffect(() => {
    if(props.data) {
      languagePages = props.data.filter((page: any) => page.pageLanguage === website_language);
      for(let i = 0; i < languagePages.length; i++) {
          orderedPagesArray[i] = languagePages.filter((page: any) => page.pageOrder === i)[0];
      }
      setPages(orderedPagesArray);
    }
  }, [props.data])

  return (
    <NavBarContainer>
      <div
        className='w-full h-full
                  lg:flex items-center
                  hidden'
      >
        {
          pages && pages.map((page: any, index: number) => (
            <>
              { index < 6 ?
                  page.subPages.length < 1 ? 
                  (
                    <SimplePageLinkForWebView 
                      page={page}
                      index={index}
                      key={index}
                    />
                  )
                  :
                  (
                    <DropdownPageLinkForWebView 
                      page={page}
                      key={index}
                      index={index}
                    />
                  ) 
                : ""
              }
            </>
          ))
        }
        {
          (props.data && props.data.filter((page: any) => page.pageLanguage === website_language).length > 6) ? <MorePages pages={props.data} /> : ""
        }
      </div>
      <div
        className='w-full
                  flex items-center
                  lg:hidden'
      >
        <div
          className='w-[62px] h-[62px]
                    ml-auto
                    flex items-center'
        > 
          <p
            className="text-white mr-2"
          >
            {website_language === "EN" ? "Menu" : "Meniu"}
          </p>
          <div
            className='w-[36px] h-[36px]
                      flex items-center
                      hover:bg-white/10
                      rounded-md
                      p-1
                      cursor-pointer
                      stroke-white'
              onClick={() => setMobileNavBar(true)}
          >
            <NavBarHamburgerIconMobile />
          </div>
        </div>
        {
          mobileNavBar && (
            <div
              className='absolute
                        w-full min-h-screen
                        bg-white
                        top-0 left-0
                        flex flex-col items-center
                        p-2'
            >
              <div
                className='flex items-center ml-auto
                          hover:bg-black/20
                          p-1
                          rounded-md
                          cursor-pointer
                          mb-8'
                onClick={() => setMobileNavBar(false)}
              >
                
                <NavBarCrossIconMobile />
              </div>
              {
                pages && pages.map((page: any, index: number) => (
                  <>
                    {
                      page.subPages.length < 1 ? 
                      (
                        <SimplePageLinkForMobileView 
                          page={page}
                          key={index}
                          index={index}
                          closeMobileNavBarFunction={setMobileNavBar}
                        />
                      )
                      :
                      (
                        <DropdownPageLinkForMobileView 
                          key={index}
                          page={page}
                          index={index}
                          closeMobileNavBarFunction={setMobileNavBar}
                        />
                      )
                    }
                  </>
                ))
              }
        </div>
          )
        }
      </div>
    </NavBarContainer>
  )
}

export default NavBar